import { Tag } from '@blueprintjs/core';
import { ReactNode } from 'react';
import { formatDatetime } from '../../../utils/formatDate';

export function CreatedAtTag({
  label,
  createdAt,
}: {
  label: ReactNode;
  createdAt: string | Date;
}) {
  return (
    <Tag minimal>
      <span>{label}</span>
      <span> {formatDatetime(createdAt)}</span>
    </Tag>
  );
}
